import { z } from 'zod/v4';

export const driverVehicleLinkSchema = z.object({
  vehicleId: z.string(),
  integrationVehicleId: z.string(),
  driverId: z.string(),
  integrationDriverId: z.string(),
  isMainDriver: z.boolean(),
});

export type DriverVehicleLink = z.infer<typeof driverVehicleLinkSchema>;
